import { DateTime } from 'luxon';

import type { OfferComment } from '../types';

const formatOfferCommentDate = (dateString?: string): string => {
    if (!dateString) return '';

    const date = DateTime.fromISO(dateString);
    return date.isValid ? date.toFormat('LLL d, h:mm a') : '';
};

export const toOfferComment = (
    versionComment: string | undefined,
    publisherName: string,
    versionCreatedOn?: string
): OfferComment | undefined => {
    const comment = versionComment?.trim();
    if (!comment) return undefined;

    const meta = [publisherName.trim(), formatOfferCommentDate(versionCreatedOn)].filter(Boolean).join(' · ');
    return { comment, meta };
};
